import { css } from "@emotion/css";

import { Text } from "../../../foundations/typography/Text";

import { Badge } from "./assets/badge";
import { Scale } from "./assets/scale";
import { Config, Range } from "./types";

export type { Config, Range };

interface Props {
  config: Config;
  score: number;
}

export function RangeGraph(props: Props) {
  const { config } = props;
  return (
    <span className={styles.container}>
      <Text color="text-weak" style="global/body-primary">
        {config.minRange}
      </Text>
      <div className={styles.score}>
        <Scale config={config} />
        {!!props.score && <Badge score={props.score} config={config} />}
      </div>
      <Text color="text-weak" style="global/body-primary">
        {config.maxRange}
      </Text>
    </span>
  );
}

const styles = {
  container: css({
    width: "100%",
    display: "inline-flex",
    gap: "var(--space-2)",
    height: 80, // required so entire component takes up space in parent container
  }),
  score: css({
    position: "relative",
    width: "100%",
  }),
};

export const config: Config = {
  minRange: 300,
  maxRange: 900,
  ranges: [
    {
      min: 300,
      max: 579,
      backgroundColor: "var(--tofino-1000)",
    },
    {
      min: 580,
      max: 669,
      backgroundColor: "var(--tofino-800)",
    },
    {
      min: 670,
      max: 739,
      backgroundColor: "var(--tofino-600)",
    },
    {
      min: 740,
      max: 799,
      backgroundColor: "var(--tofino-400)",
    },
    {
      min: 800,
      max: 900,
      backgroundColor: "var(--tofino-200)",
    },
  ],
};
